export default {
  TRANSFER_REQUESTS_LOAD: 'TRANSFER_REQUESTS_LOAD',
  TRANSFER_REQUESTS_FETCHED: 'TRANSFER_REQUESTS_FETCHED',
};
